/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppVisitsRouteImport } from './routes/_app/visits'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppMaintenanceServicesRouteImport } from './routes/_app/maintenance-services'
import { Route as AppMaintenanceCostsRouteImport } from './routes/_app/maintenance-costs'
import { Route as AppMaintenanceRouteImport } from './routes/_app/maintenance'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppConsumptionRouteImport } from './routes/_app/consumption'
import { Route as AppMessagesIndexRouteImport } from './routes/_app/messages/index'
import { Route as AppMaintenanceLogIndexRouteImport } from './routes/_app/maintenance-log.index'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth.google.callback'
import { Route as AppVisitIdRouteImport } from './routes/_app/visit.$id'
import { Route as AppMessagesIdRouteImport } from './routes/_app/messages/$id'
import { Route as AppMaintenanceLogIdRouteImport } from './routes/_app/maintenance-log.$id'
import { Route as AppPropertyPropertyIdIndexRouteImport } from './routes/_app/property.$propertyId/index'

const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVisitsRoute = AppVisitsRouteImport.update({
  id: '/visits',
  path: '/visits',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceServicesRoute = AppMaintenanceServicesRouteImport.update({
  id: '/maintenance-services',
  path: '/maintenance-services',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceCostsRoute = AppMaintenanceCostsRouteImport.update({
  id: '/maintenance-costs',
  path: '/maintenance-costs',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceRoute = AppMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppConsumptionRoute = AppConsumptionRouteImport.update({
  id: '/consumption',
  path: '/consumption',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceLogIndexRoute = AppMaintenanceLogIndexRouteImport.update({
  id: '/maintenance-log/',
  path: '/maintenance-log/',
  getParentRoute: () => AppRoute,
} as any)
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
  id: '/auth/google/callback',
  path: '/auth/google/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVisitIdRoute = AppVisitIdRouteImport.update({
  id: '/visit/$id',
  path: '/visit/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIdRoute = AppMessagesIdRouteImport.update({
  id: '/messages/$id',
  path: '/messages/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceLogIdRoute = AppMaintenanceLogIdRouteImport.update({
  id: '/maintenance-log/$id',
  path: '/maintenance-log/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertyPropertyIdIndexRoute =
  AppPropertyPropertyIdIndexRouteImport.update({
    id: '/property/$propertyId/',
    path: '/property/$propertyId/',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/consumption': typeof AppConsumptionRoute
  '/home': typeof AppHomeRoute
  '/maintenance': typeof AppMaintenanceRoute
  '/maintenance-costs': typeof AppMaintenanceCostsRoute
  '/maintenance-services': typeof AppMaintenanceServicesRoute
  '/profile': typeof AppProfileRoute
  '/visits': typeof AppVisitsRoute
  '/maintenance-log/$id': typeof AppMaintenanceLogIdRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/visit/$id': typeof AppVisitIdRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/maintenance-log': typeof AppMaintenanceLogIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/property/$propertyId': typeof AppPropertyPropertyIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/consumption': typeof AppConsumptionRoute
  '/home': typeof AppHomeRoute
  '/maintenance': typeof AppMaintenanceRoute
  '/maintenance-costs': typeof AppMaintenanceCostsRoute
  '/maintenance-services': typeof AppMaintenanceServicesRoute
  '/profile': typeof AppProfileRoute
  '/visits': typeof AppVisitsRoute
  '/maintenance-log/$id': typeof AppMaintenanceLogIdRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/visit/$id': typeof AppVisitIdRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/maintenance-log': typeof AppMaintenanceLogIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/property/$propertyId': typeof AppPropertyPropertyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/_app/consumption': typeof AppConsumptionRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/maintenance': typeof AppMaintenanceRoute
  '/_app/maintenance-costs': typeof AppMaintenanceCostsRoute
  '/_app/maintenance-services': typeof AppMaintenanceServicesRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/visits': typeof AppVisitsRoute
  '/_app/maintenance-log/$id': typeof AppMaintenanceLogIdRoute
  '/_app/messages/$id': typeof AppMessagesIdRoute
  '/_app/visit/$id': typeof AppVisitIdRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/_app/maintenance-log/': typeof AppMaintenanceLogIndexRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/property/$propertyId/': typeof AppPropertyPropertyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/consumption'
    | '/home'
    | '/maintenance'
    | '/maintenance-costs'
    | '/maintenance-services'
    | '/profile'
    | '/visits'
    | '/maintenance-log/$id'
    | '/messages/$id'
    | '/visit/$id'
    | '/auth/google/callback'
    | '/maintenance-log'
    | '/messages'
    | '/property/$propertyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/consumption'
    | '/home'
    | '/maintenance'
    | '/maintenance-costs'
    | '/maintenance-services'
    | '/profile'
    | '/visits'
    | '/maintenance-log/$id'
    | '/messages/$id'
    | '/visit/$id'
    | '/auth/google/callback'
    | '/maintenance-log'
    | '/messages'
    | '/property/$propertyId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/impersonate'
    | '/_app/consumption'
    | '/_app/home'
    | '/_app/maintenance'
    | '/_app/maintenance-costs'
    | '/_app/maintenance-services'
    | '/_app/profile'
    | '/_app/visits'
    | '/_app/maintenance-log/$id'
    | '/_app/messages/$id'
    | '/_app/visit/$id'
    | '/auth/google/callback'
    | '/_app/maintenance-log/'
    | '/_app/messages/'
    | '/_app/property/$propertyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
  AuthGoogleCallbackRoute: typeof AuthGoogleCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/visits': {
      id: '/_app/visits'
      path: '/visits'
      fullPath: '/visits'
      preLoaderRoute: typeof AppVisitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-services': {
      id: '/_app/maintenance-services'
      path: '/maintenance-services'
      fullPath: '/maintenance-services'
      preLoaderRoute: typeof AppMaintenanceServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-costs': {
      id: '/_app/maintenance-costs'
      path: '/maintenance-costs'
      fullPath: '/maintenance-costs'
      preLoaderRoute: typeof AppMaintenanceCostsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance': {
      id: '/_app/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof AppMaintenanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/consumption': {
      id: '/_app/consumption'
      path: '/consumption'
      fullPath: '/consumption'
      preLoaderRoute: typeof AppConsumptionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-log/': {
      id: '/_app/maintenance-log/'
      path: '/maintenance-log'
      fullPath: '/maintenance-log'
      preLoaderRoute: typeof AppMaintenanceLogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/google/callback': {
      id: '/auth/google/callback'
      path: '/auth/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/visit/$id': {
      id: '/_app/visit/$id'
      path: '/visit/$id'
      fullPath: '/visit/$id'
      preLoaderRoute: typeof AppVisitIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/$id': {
      id: '/_app/messages/$id'
      path: '/messages/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof AppMessagesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance-log/$id': {
      id: '/_app/maintenance-log/$id'
      path: '/maintenance-log/$id'
      fullPath: '/maintenance-log/$id'
      preLoaderRoute: typeof AppMaintenanceLogIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/property/$propertyId/': {
      id: '/_app/property/$propertyId/'
      path: '/property/$propertyId'
      fullPath: '/property/$propertyId'
      preLoaderRoute: typeof AppPropertyPropertyIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppConsumptionRoute: typeof AppConsumptionRoute
  AppHomeRoute: typeof AppHomeRoute
  AppMaintenanceRoute: typeof AppMaintenanceRoute
  AppMaintenanceCostsRoute: typeof AppMaintenanceCostsRoute
  AppMaintenanceServicesRoute: typeof AppMaintenanceServicesRoute
  AppProfileRoute: typeof AppProfileRoute
  AppVisitsRoute: typeof AppVisitsRoute
  AppMaintenanceLogIdRoute: typeof AppMaintenanceLogIdRoute
  AppMessagesIdRoute: typeof AppMessagesIdRoute
  AppVisitIdRoute: typeof AppVisitIdRoute
  AppMaintenanceLogIndexRoute: typeof AppMaintenanceLogIndexRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
  AppPropertyPropertyIdIndexRoute: typeof AppPropertyPropertyIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppConsumptionRoute: AppConsumptionRoute,
  AppHomeRoute: AppHomeRoute,
  AppMaintenanceRoute: AppMaintenanceRoute,
  AppMaintenanceCostsRoute: AppMaintenanceCostsRoute,
  AppMaintenanceServicesRoute: AppMaintenanceServicesRoute,
  AppProfileRoute: AppProfileRoute,
  AppVisitsRoute: AppVisitsRoute,
  AppMaintenanceLogIdRoute: AppMaintenanceLogIdRoute,
  AppMessagesIdRoute: AppMessagesIdRoute,
  AppVisitIdRoute: AppVisitIdRoute,
  AppMaintenanceLogIndexRoute: AppMaintenanceLogIndexRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
  AppPropertyPropertyIdIndexRoute: AppPropertyPropertyIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
  AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
